/**
 * Données des villes de Suisse romande pour les landing pages métier+ville.
 * Chaque ville a : nom, canton, slug URL, image landmark, description locale, population.
 */

export const VILLES = {
  geneve: {
    nom: "Genève",
    canton: "Genève",
    slug: "geneve",
    population: "205 000",
    image: "https://images.unsplash.com/photo-1762699337284-eeced9936b3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxHZW5ldmElMjBTd2l0emVybGFuZCUyMGNpdHlzY2FwZSUyMGpldCUyMGQlMjdlYXV8ZW58MHx8fHwxNzg5MjI1ODYwfDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Vue du Jet d'eau de Genève",
    landmark: "Jet d'eau",
    description: "Capitale internationale au bord du Léman, Genève concentre un parc immobilier dense et diversifié avec une forte demande de rénovation et d'entretien.",
    quartiers: ["Eaux-Vives", "Carouge", "Plainpalais", "Champel", "Pâquis"],
    contexte: "Avec ses immeubles historiques et ses projets neufs, Genève offre un flux constant de chantiers pour les artisans qualifiés.",
  },
  lausanne: {
    nom: "Lausanne",
    canton: "Vaud",
    slug: "lausanne",
    population: "145 000",
    image: "https://images.unsplash.com/photo-1777924154462-691ac3ab409a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxMYXVzYW5uZSUyMFN3aXR6ZXJsYW5kJTIwY2l0eXNjYXBlJTIwY2F0aGVkcmFsfGVufDB8fHx8MTc4OTIyNTg2MXww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Cathédrale de Lausanne",
    landmark: "Cathédrale",
    description: "Capitale olympique nichée dans les collines du Léman, Lausanne connaît un essor immobilier important avec de nombreux projets de rénovation.",
    quartiers: ["Flon", "Ouchy", "Chailly", "Sous-Gare", "Montbenon"],
    contexte: "Entre bâtiments patrimoniaux et constructions modernes, les artisans lausannois sont très sollicités toute l'année.",
  },
  fribourg: {
    nom: "Fribourg",
    canton: "Fribourg",
    slug: "fribourg",
    population: "40 000",
    image: "https://images.unsplash.com/photo-1609770264759-fd0f26b0de92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxGcmlib3VyZyUyMFN3aXR6ZXJsYW5kJTIwb2xkJTIwdG93biUyMGJyaWRnZXxlbnwwfHx8fDE3ODkyMjU4NjF8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Vieille ville de Fribourg et la Sarine",
    landmark: "Pont de Berne",
    description: "Ville médiévale bilingue avec un patrimoine architectural riche, Fribourg génère une demande constante en restauration et travaux spécialisés.",
    quartiers: ["Bourg", "Auge", "Pérolles", "Beauregard", "Schönberg"],
    contexte: "La restauration du patrimoine médiéval et les projets résidentiels font de Fribourg un marché dynamique pour les artisans.",
  },
  neuchatel: {
    nom: "Neuchâtel",
    canton: "Neuchâtel",
    slug: "neuchatel",
    population: "35 000",
    image: "https://images.unsplash.com/photo-1528493366314-e317cd98dd52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxOZXVjaGF0ZWwlMjBTd2l0emVybGFuZCUyMGxha2UlMjBjaXR5fGVufDB8fHx8MTc4OTIyNTg2MXww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Vue du lac de Neuchâtel",
    landmark: "Lac de Neuchâtel",
    description: "Ville horlogère au bord du plus grand lac entièrement suisse, Neuchâtel combine bâtiments historiques et logements modernes.",
    quartiers: ["Maladière", "Serrières", "Vieux-Châtel", "La Coudre", "Monruz"],
    contexte: "Les nombreuses rénovations de bâtiments anciens et l'expansion résidentielle offrent de belles opportunités aux artisans neuchâtelois.",
  },
  sion: {
    nom: "Sion",
    canton: "Valais",
    slug: "sion",
    population: "35 000",
    image: "https://images.unsplash.com/photo-1635716076455-9c0e4ebd9451?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxTaW9uJTIwU3dpdHplcmxhbmQlMjBWYWxhaXMlMjBjYXN0bGV8ZW58MHx8fHwxNzg5MjI1ODYwfDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Château de Tourbillon à Sion",
    landmark: "Château de Tourbillon",
    description: "Capitale du Valais entre vignobles et montagnes, Sion allie patrimoine historique et développement immobilier dynamique.",
    quartiers: ["Vieille Ville", "Bramois", "Châteauneuf", "Uvrier", "Pont-de-la-Morge"],
    contexte: "Avec le boom de la construction en Valais et les rénovations énergétiques, les artisans sédunois ne manquent pas de travail.",
  },
  montreux: {
    nom: "Montreux",
    canton: "Vaud",
    slug: "montreux",
    population: "27 000",
    image: "https://images.unsplash.com/photo-1684050879098-87151a1ded14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxNb250cmV1eCUyMFN3aXR6ZXJsYW5kJTIwbGFrZSUyMG1vdW50YWluc3xlbnwwfHx8fDE3ODkyMjU4Njl8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Montreux et le lac Léman avec les Alpes",
    landmark: "Château de Chillon",
    description: "Perle de la Riviera vaudoise, Montreux attire propriétaires et investisseurs avec des biens immobiliers haut de gamme nécessitant un entretien régulier.",
    quartiers: ["Territet", "Clarens", "Veytaux", "Glion", "Caux"],
    contexte: "Les résidences de standing et le tourisme haut de gamme créent une demande continue pour des artisans qualifiés à Montreux.",
  },
  nyon: {
    nom: "Nyon",
    canton: "Vaud",
    slug: "nyon",
    population: "22 000",
    image: "https://images.unsplash.com/photo-1682244069060-bf1ab1e450b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxOeW9uJTIwU3dpdHplcmxhbmQlMjBsYWtlJTIwR2VuZXZhJTIwY2FzdGxlfGVufDB8fHx8MTc4OTIyNTg2OXww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Château de Nyon au bord du Léman",
    landmark: "Château de Nyon",
    description: "Entre Genève et Lausanne, Nyon est une ville en pleine croissance avec de nombreux projets résidentiels et commerciaux.",
    quartiers: ["Vieille Ville", "Rive", "Prangins", "Crans", "Eysins"],
    contexte: "L'axe Genève-Lausanne fait exploser la demande immobilière à Nyon, un marché en or pour les artisans locaux.",
  },
  yverdon: {
    nom: "Yverdon-les-Bains",
    canton: "Vaud",
    slug: "yverdon",
    population: "31 000",
    image: "https://images.unsplash.com/photo-1780220735216-df2424cd1cac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxZdmVyZG9uLWxlcy1CYWlucyUyMFN3aXR6ZXJsYW5kJTIwY2FzdGxlJTIwdG93bnxlbnwwfHx8fDE3ODkyMjU4Njl8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Château médiéval d'Yverdon-les-Bains",
    landmark: "Château d'Yverdon",
    description: "Ville thermale au sud du lac de Neuchâtel, Yverdon-les-Bains connaît un renouveau urbain avec de nombreux chantiers de rénovation.",
    quartiers: ["Centre-ville", "Pierre-de-Savoie", "Cheminet", "Fontenay", "Villette"],
    contexte: "Le pôle technologique Y-Parc et les rénovations du centre-ville dynamisent la demande en artisans à Yverdon.",
  },
  bienne: {
    nom: "Bienne",
    canton: "Berne",
    slug: "bienne",
    population: "56 000",
    image: "https://images.unsplash.com/photo-1599082323832-2676eca28e86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxCaWVsJTIwQmllbm5lJTIwU3dpdHplcmxhbmQlMjBjaXR5JTIwbGFrZXxlbnwwfHx8fDE3ODkyMjU4Njl8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Vue aérienne de Bienne au bord du lac",
    landmark: "Lac de Bienne",
    description: "Plus grande ville bilingue de Suisse, Bienne combine industrie horlogère et développement résidentiel avec un parc immobilier varié.",
    quartiers: ["Vieille Ville", "Madretsch", "Bözingen", "Mett", "Champagne"],
    contexte: "La croissance démographique et les projets de rénovation urbaine font de Bienne un marché porteur pour les artisans.",
  },
  delemont: {
    nom: "Delémont",
    canton: "Jura",
    slug: "delemont",
    population: "12 500",
    image: "https://images.unsplash.com/photo-1687443824481-4f316e95d647?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxKdXJhJTIwU3dpdHplcmxhbmQlMjBzbWFsbCUyMHRvd24lMjBtZWRpZXZhbHxlbnwwfHx8fDE3ODkyMjU4Nzh8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Église historique du Jura suisse",
    landmark: "Vieille Ville",
    description: "Capitale du canton du Jura, Delémont est une ville à taille humaine où les artisans locaux sont les piliers de l'économie du bâtiment.",
    quartiers: ["Vieille Ville", "La Communance", "Pré Monsieur", "Montcroix", "Vorbourg"],
    contexte: "La proximité avec la France voisine et les projets cantonaux offrent un marché stable pour les artisans jurassiens.",
  },
};

export const VILLE_SLUGS = Object.keys(VILLES);

export default VILLES;
